import React, { useEffect, useMemo, useState } from "react";
import { View, Text } from "react-native";
import { observer } from "mobx-react";
import { useTranslation } from "react-i18next";
import IconEmptyView from "../../Components/IconEmptyView";
import ExerciseHistoryRow from "./ExerciseHistoryRow";
import Colors from "../../../Resources/Color";
import { useDevice } from "../../_layout";
import HoverableTouchableOpacity from "../../Components/HoverableTouchableOpacity";

const ExerciseHistoryList = observer(
  ({ client, exercise, containerStyle, initialBlocksToShow = 2 }) => {
    const { t, i18n } = useTranslation();
    const { isMobile } = useDevice();
    const [shownBlocks, setShownBlocks] = useState(initialBlocksToShow);
    const [isSeeMoreHovered, setIsSeeMoreHovered] = useState(false);

    useEffect(() => {
      setShownBlocks(initialBlocksToShow);
    }, [exercise?.id, initialBlocksToShow]);

    const selectedWorkout = exercise?.workout ?? null;

    const historyExercises = useMemo(() => {
      if (!client || !exercise || !selectedWorkout) return [];
      return client.getExercisesForHistory(selectedWorkout, t, i18n.language, {
        exercise,
        limitBlocks: shownBlocks,
      });
    }, [client, exercise, selectedWorkout, t, i18n.language, shownBlocks]);

    const totalBlocksWithExercise = useMemo(() => {
      if (!client || !exercise || !selectedWorkout) return 0;
      return client.getTotalBlocksWithExercise(t, i18n.language, {
        exercise,
        selectedWorkout,
      });
    }, [client, exercise, selectedWorkout, t, i18n.language]);

    const showSeeMore = shownBlocks < totalBlocksWithExercise;

    return (
      <View
        style={[{ marginHorizontal: 12, marginBottom: 12 }, containerStyle]}
      >
        {historyExercises.length === 0 ? (
          <IconEmptyView
            iconLibrary={"Ionicons"}
            mainText={"emptyHistoryTitle-string"}
            subText={"emptyHistoryText-string"}
            iconName={"list"}
            marginTop={40}
            marginBottom={0}
          />
        ) : (
          <>
            {historyExercises.map((historyExercise, index, array) => (
              <ExerciseHistoryRow
                key={historyExercise.id}
                exercise={historyExercise}
                isFirst={index === 0}
                isLast={index === array.length - 1}
              />
            ))}
            {showSeeMore && (
              <HoverableTouchableOpacity
                style={{
                  alignSelf: "center",
                  marginBottom: 10,
                  marginTop: 10,
                }}
                hoverStyle={undefined}
                onPress={() => setShownBlocks((prev) => prev + 1)}
                onMouseEnter={() => !isMobile && setIsSeeMoreHovered(true)}
                onMouseLeave={() => setIsSeeMoreHovered(false)}
              >
                <Text
                  style={{
                    color: Colors.bubbleColor,
                    fontWeight: isSeeMoreHovered ? "500" : "normal",
                  }}
                >
                  {t("seeMore-string")}
                </Text>
              </HoverableTouchableOpacity>
            )}
          </>
        )}
      </View>
    );
  }
);

export default ExerciseHistoryList;
